import clsx from 'clsx'
// import {useLayout} from 'layout/master-layout'
// import i18n from 'i18next'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

type itemProps = {
 url: string
 name: string
}

const Footer = () => {
 //  const {classes} = useLayout()
 const {t} = useTranslation()

 const links: itemProps[] = t('footer.links', {
  returnObjects: true,
 }) as itemProps[]

 return (
  <div className={'footer d-flex flex-lg-column'} id=''>
   <div className={clsx('bg-[#3B68BB]')}>
    <div className='md:flex-row md:flex-nowrap md:justify-center flex items-center py-2 container text-white text-sm font-medium'>
     {links.map((link: itemProps, i: number) => (
      <Link key={i} to={link.url} className='text-white'>
       {link.name}
      </Link>
     ))}
    </div>
   </div>
   <div className={clsx('bg-[#1A3870] py-2')}>
    <div className='text-center container text-white text-base font-medium py-2'>
     {/* <div>{t('footer.social')}</div> */}
     <div>{t('footer.copyright')}</div>
    </div>
   </div>
  </div>
 )
}

export {Footer}
